import React, { Component } from "react";
import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
import Modal from "react-responsive-modal";
import { Button, Label } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// eslint-disable-next-line react/prefer-stateless-function
class DocToTemplatePopup extends Component {
  state = {
    templateName: `${this.props.docName} Template`,
  };

  componentDidMount() {
    this.documentNameInput.focus();
  }

  handleTemplateName = e => {
    this.setState({
      templateName: e.target.value,
    });
  };

  render() {
    return (
      <Modal
        open
        onClose={this.props.togglePopup}
        center
        closeOnOverlayClick={false}>
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div
            className="quotationtopbar-modal-heading"
            data-test="quotationtopbar-modal-heading">
            Name the template you are creating from this document
          </div>
          <div className="quotationtopbar-form">
            <div className="quotationtopbar-form-field">
              <Label
                htmlFor="userEmail"
                data-test="quotationtopbar-input-label">
                Enter template name here
              </Label>
              <input
                className="form-control"
                data-test="quotationtopbar-docname-inputfield"
                type="text"
                name="documentName"
                value={this.state.templateName}
                onChange={this.handleTemplateName}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    // Set a delay to update in redux before calling saveDocAsTemplate
                    setTimeout(() => this.props.saveDocAsTemplate(), 100);
                  }
                }}
                placeholder="Enter a template name"
                ref={name => {
                  this.documentNameInput = name;
                }}
              />
            </div>
          </div>
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              onClick={this.props.togglePopup}
              data-test="quotationtopbar-docname-cancel-button">
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              data-test="quotationtopbar-docname-proceed-button"
              onClick={() => this.props.saveDocAsTemplate()}>
              <i>
                <FontAwesomeIcon icon={["far", "plus"]} />
              </i>
              Create template
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { document: { name: docName } = {} } = state.DocumentStore;

  return {
    docName,
  };
};

export default connect(
  mapStateToProps,
  null,
)(DocToTemplatePopup);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/DocToTemplate/DocToTemplatePopup/index.js